'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ugcIOwnThisShape = _reactImmutableProptypes2.default.contains({
  id: _react.PropTypes.number.isRequired,
  metadataId: _react.PropTypes.string.isRequired,
  userId: _react.PropTypes.number.isRequired
});

exports.default = ugcIOwnThisShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/ugcIOwnThisShape.js
// module id = 1386
// module chunks = 1